import { Observable } from 'rxjs';
import { TpvTerminal } from '@app/domain/models/tpv/terminal.model';
import { TpvListQuery, TpvPage } from '@app/domain/models/tpv/tpv-page.model';

export interface TerminalListQuery extends TpvListQuery {}

/**
 * Port de lectura del directorio de terminales.
 * `externalIdMerchant` (UUID, `id_merchant`) es OBLIGATORIO.
 */
export abstract class TerminalRepository {
  abstract getTerminals(
    externalIdMerchant: string,
    query?: TerminalListQuery,
  ): Observable<TpvPage<TpvTerminal>>;
}
